import { reducerWithInitialState } from 'typescript-fsa-reducers';

type ExpressOrderInfo = {
    // eslint-disable-next-line camelcase
    arrow_type: string;
    description: string;
    enable: boolean;
};

type ExpressOrderReducer = Array<ExpressOrderInfo>;

const initState: ExpressOrderReducer = [];

export const expressOrderReducer = reducerWithInitialState(initState);
